// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XTCRP","importantInfo":"styles_importantInfo__3S7EM"};